import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { landingPageImages } from '../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={FlyoutProductCreationFaqSection.BUYER_REGISTRATION_FORM_FIELDS}
        question="Can I remove the first 3 form fields?"
      />
    ),
    answer: (
      <div>
        No, those are mandatory form fields which every user is required to
        fill. You can however add any number of new custom fields in the buyer
        registration page.
      </div>
    ),
  },
]

interface FlyoutProductFormFieldsFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const FlyoutProductFormFieldsFaqs: React.FC<
  FlyoutProductFormFieldsFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Form Fields"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={landingPageImages.slice(0, 1)}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
